import { Button } from 'components';
import { RequestRecoveryPasswordForm } from 'components/Forms/Auth/RequestRecoveryPasswordForm';
import { AuthTemplate } from 'components/templates/AuthTemplate';
import { useDisclose } from 'hooks/utilHooks';
import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { requestRecoveryPasswordTokenValidation } from 'schemas/authValidation';
import { AuthService } from 'services';
import { IRequestRecoveryPassword, ISignIn, TitleByUserRole } from 'types/Auth';

import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';

export const RequestRecoveryPasswordPage: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState('');
  const { isOpen, onClose, onOpen } = useDisclose();

  const { userRole } = useParams<{ userRole: ISignIn['role'] }>();

  const form = useForm<IRequestRecoveryPassword>({
    defaultValues: { cpf: '', email: '', role: userRole },
    resolver: requestRecoveryPasswordTokenValidation(userRole),
  });

  const title = TitleByUserRole[userRole];
  document.title = title;

  const onSubmit = async (values: IRequestRecoveryPassword) => {
    try {
      setLoading(true);
      setError('');

      await AuthService.requestRecoveryPasswordToken(values);
      onOpen();
    } catch (reason) {
      const { message } = reason as Error;
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form>
      <FormProvider {...form}>
        <AuthTemplate
          title={title}
          error={error}
          loading={loading}
          userRole={userRole}
        >
          <RequestRecoveryPasswordForm>
            <Button
              fullWidth
              sx={{ mb: 2 }}
              type="submit"
              onClick={form.handleSubmit(onSubmit)}
            >
              RECEBER INSTRUÇÕES
            </Button>
          </RequestRecoveryPasswordForm>
        </AuthTemplate>

        <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
          <DialogTitle>
            Redefinição de senha
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <DialogContentText>
              Um link de recuperação foi enviado para seu e-mail. Verifique sua
              caixa de entrada e spam
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button variant="text" onClick={onClose}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </form>
  );
};

